import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import { FaChevronDown } from "react-icons/fa";
const SelectInputCategories = ({
    onChange,
    labelName,
    options,
    defaultValue,
    disabled,
    errorOccured,
    errorMessage,
    isForCatId = false,
    isRequired = false,
}) => {
    const [activated, setActivated] = useState(true);
    const labelRef = useRef();
    const [coverWidth, setCoverWidth] = useState(0);

    useEffect(() => {
        setCoverWidth(
            labelRef.current ? labelRef.current.getBoundingClientRect().width + 9 : 0
        );
        // if (options?.length > 0) {
        //     setActivated(true);
        // }
    }, [labelRef]);
    return (
        <>

            <div className="col-12 mb-4">
                <InputGroup
                    className={`${errorOccured ? "" : "mb-2"} position-relative`}
                    onFocus={() => {
                        setActivated(true);
                    }}
                >
                    {" "}
                    <>
                        <Form.Group controlId="exampleForm.SelectCustom" className="col-12 border-danger">
                            {/* <Form.Label>Select Options</Form.Label> */}
                            <Form.Label
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-activated"
                                    : "textfield-label-unactivated"
                                    } textfield-label`}
                                ref={labelRef}
                                onClick={() => {
                                    setActivated(true);
                                }}>
                                <strong className={`${errorOccured && 'text-danger'}`}> {labelName} {isRequired ? '*' : ""}</strong>
                            </Form.Label>
                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover `}
                                style={{ width: coverWidth }}></div>
                            <Form.Control
                                className={`${errorOccured && 'border-danger'}`}
                                as="select"
                                custom
                                required
                                onChange={onChange}
                                defaultValue={defaultValue}
                                disabled={disabled}>
                                <option value={''} disabled>Select category</option>
                                {options?.map((option) => (
                                    <option value={isForCatId ? option.category_id_ids : option.category_name_chr}>
                                        {option.category_display_name_chr}
                                    </option>
                                ))}
                            </Form.Control>

                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover`}
                                style={{ width: "20px" }}></div>
                        </Form.Group>

                        <FaChevronDown style={{
                            position: 'absolute',
                            right: '10px',
                            top: errorOccured ? '38%' : '50%',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none',
                            color: errorOccured ? 'red' : 'gray'
                        }} />
                    </>
                    {errorOccured && (
                        <span style={{ color: "red", fontSize: "10px" }}>
                            {errorMessage}
                        </span>
                    )}
                </InputGroup>
            </div>
        </>
    );
};

export default SelectInputCategories;
